import { render, staticRenderFns } from "./contentCard.vue?vue&type=template&id=6b0f0fa5&scoped=true"
import script from "./contentCard.vue?vue&type=script&lang=js"
export * from "./contentCard.vue?vue&type=script&lang=js"
import style0 from "./contentCard.vue?vue&type=style&index=0&id=6b0f0fa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f0fa5",
  null
  
)

export default component.exports